import {customElement, containerless} from "aurelia-framework";

@containerless()
@customElement("onebox-view-header")
export class OneboxHeader {
}
